const React = require("react");
const { NavLink, Outlet } = require("react-router-dom");
const { useSyncee } = require("../context/SynceeContext");
const { getSynceeNavigation } = require("../navigation");
const { SYNCEE_CSS } = require("../styles");
const h = React.createElement;

const SynceeLayout = () => {
  const { t, isAdmin } = useSyncee();
  return h("div", { className: "synds-shell" }, h("style", null, SYNCEE_CSS),
    h("header", { className: "synds-top" }, h("h1", null, t("h_syncee_title", "Syncee Dropshipping")), h("p", null, t("h_syncee_subtitle", "Connect suppliers, import products and keep your Elakay catalog synchronized."))),
    h("nav", { className: "synds-nav", "aria-label": t("h_syncee_navigation", "Syncee navigation") }, ...getSynceeNavigation(t, { isAdmin }).map((item) => h(NavLink, { key: item.to, to: item.to, className: ({ isActive }) => isActive ? "active" : "" }, item.label))),
    h("main", { className: "synds-main" }, h(Outlet))
  );
};
module.exports = { SynceeLayout };
